import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

/**
 * Stops a click or touchstart event
 * from bubbling up the DOM.
 */
@Directive({
  selector: '[appStopClickBubble]'
})
export class StopClickBubbleDirective {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input() outsideClickIgnoreEls: Element[];

  @Output() outsideClicked = new EventEmitter<any>();

  constructor(
    private _el: ElementRef
  ) {
  }

  @HostListener('click', ['$event'])
  @HostListener('touchstart', ['$event'])
  stopBubble(event: KeyboardEvent) {
    event.stopImmediatePropagation();
  }
}
